import { render } from "./Configure.vue?vue&type=template&id=27416a18"
import script from "./Configure.vue?vue&type=script&lang=js"
export * from "./Configure.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__